import { render, staticRenderFns } from "./LeaderBoardTimer.vue?vue&type=template&id=79ebea85&"
import script from "./LeaderBoardTimer.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports